module.exports = __webpack_public_path__ + "static/media/experience--all.fd220561.svg";